export default __webpack_public_path__ + "static/media/vip-2.77c5972a.svg";